/* eslint-disable @typescript-eslint/ban-types */
import React, { useEffect } from 'react';
import { CloseSquare, TickSquare, InfoSquare } from 'react-iconly';
import { ToastMessage, useToast } from '../../../hooks/toast';
import { Container } from './styles';

interface ToastProps {
  message: ToastMessage;
  style: object;
}

const icons = {
  info: <InfoSquare size={24} />,
  error: <CloseSquare size={24} />,
  success: <TickSquare size={24} />,
  alert: <InfoSquare size={24} primaryColor="orange" />,
};

const Toast: React.FC<ToastProps> = ({ message, style }) => {
  const { removeToast } = useToast();

  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(message.id);
    }, 10000);

    return () => {
      clearTimeout(timer);
    };
  }, [removeToast, message.id]);

  return (
    <Container
      type={message.type}
      has_description={Number(!!message.description)}
      style={style}
    >
      {icons[message.type || 'info']}

      <div>
        <div className="side" />
        <h4>{message.title}</h4>
        {message.description && <h3>{message.description}</h3>}
      </div>

      <button onClick={() => removeToast(message.id)} type="button">
        <h3>x</h3>
      </button>
    </Container>
  );
};

export default Toast;
